// extracted by mini-css-extract-plugin
export default {"dialogActions":"TokenTester_dialogActions__BjS3c"};